import {
  Box,
  Card,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import { InputSearchbox } from "components/Form/InputSearchbox";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { getAllUserComplaint } from "redux/actions";
import styled from "styled-components";
import {
  Pagination,
  PaginationDetail,
  PaginationFilter,
} from "components/Pagination";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import moment from "moment";
// import FilterKit from "components/FilterKit";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

const UserComplaintContent: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });

  const { isLoading } = useSelector((state: any) => state.globalReducer);
  const {userComplaint } =
    useSelector((state: any) => state.userComplaintReducer);
  const {
    currentPage,
    totalPage,
    limitPage,
    lengthPage,
  } = useSelector((state: any) => state.userComplaintReducer);

  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(10);

  const handleSearchChange = (event: any) => {
    setSearchValue(event.target.value);
    dispatch(
      getAllUserComplaint(
        1,
        event.target.value,
        limitPage,
  
      ) as any
    );
  };

  const handleClearSearchChange = () => {
    setSearchValue("");
    dispatch(
      getAllUserComplaint(
        currentPage,
        "",
        limitPage,

      ) as any
    );
  };

  useEffect(() => {

    dispatch(getAllUserComplaint() as any);
  }, [dispatch]);
console.log(userComplaint)
  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={"column"}
        style={{ gap: 20 }}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            User Complaint
          </Text>
        </Box>

        <Box
          display={"flex"}
          flexDirection={isTablet ? "column" : "row"}
          justifyContent={"left"}
          style={{ gap: 5 }}
        >
          <InputSearchbox
            autoComplete="off"
            name="search"
            placeholder="Search..."
            size={32}
            onChange={handleSearchChange}
            onClearButton={handleClearSearchChange}
          />

        </Box>
      </HeaderWrapper>

      <Card maxHeight={"100%"} overflow={"auto"} elevation={2}>
        <Table>
          <TableHead
            position={"sticky"}
            top={0}
            backgroundColor={theme.colors.grey02}
          >
            <TableHeadRow>
              <TableHeadCell>Username</TableHeadCell>
              <TableHeadCell>User Email</TableHeadCell>
              <TableHeadCell>Phone Number</TableHeadCell>
              <TableHeadCell minWidth={200}>Description</TableHeadCell>
              <TableHeadCell>Date/Time</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={6} />
            ) : !userComplaint.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={6} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              userComplaint.map((log: any) => {
                return (
                  <TableBodyRow key={log.name}>
                    <TableBodyCell>{log.name}</TableBodyCell>
                    <TableBodyCell>{log.email}</TableBodyCell>
                    <TableBodyCell>{log.phone}</TableBodyCell>
                    <TableBodyCell>{log.description}</TableBodyCell>
                    <TableBodyCell>
                      {moment(log.created_at).format("DD MMMM YYYY, HH:mm:ss")}
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingY={10}
      >
        {!isMobile ? (
          <PaginationDetail
            page={currentPage}
            limit={limitPage}
            length={lengthPage}
          />
        ) : (
          ""
        )}
        <Pagination
          current={currentPage}
          total={totalPage}
          onSelect={(select: any) =>
            dispatch(
              getAllUserComplaint(
                select,
                searchValue,
                limitPage,
              ) as any
            )
          }
        />
        <PaginationFilter
          selectedItem={limit}
          onChange={(selectedItem) => {
            if (selectedItem) {
              setLimit(selectedItem);
              dispatch(
                getAllUserComplaint(
                  1,
                  searchValue,
                  selectedItem,
        
                ) as any
              );
            }
          }}
          items={[10, 20, 30, 40, 50]}
        />
      </Box>
    </Box>
  );
};

export default UserComplaintContent;
